<template>
  <div class="pub-home">
    <el-card class="main">
      <h1 style="font-size: 26px; margin-bottom: 30px">更改密码</h1>
      <el-form :model="passFrom" :rules="rules" ref="passFrom">
        <el-form-item prop="username">
          <el-input
            name="username"
            type="text"
            v-model="passFrom.username"
            autoComplete="on"
            placeholder="请输入手机号"
          >
            <span slot="prefix">
              <svg-icon
                icon-class="icon-zhanghao"
                class="color-main inputSvg"
              ></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            name="password"
            type="password"
            v-model="passFrom.password"
            placeholder="请输入新密码"
            show-password
          >
            <span slot="prefix">
              <svg-icon
                icon-class="icon-mima"
                class="color-main inputSvg"
              ></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <span style="font-size: 12px; color: green"
          >密码长度大于10,且必须包含大写、小写、数字、特殊字符！</span
        >
        <el-form-item prop="npassword">
          <el-input
            name="npassword"
            type="password"
            v-model="passFrom.npassword"
            placeholder="请确认新密码"
            show-password
          >
            <span slot="prefix">
              <svg-icon
                icon-class="icon-mima"
                class="color-main inputSvg"
              ></svg-icon>
            </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-row>
            <el-col :span="14">
              <el-input
                v-model="passFrom.code"
                auto-complete="off"
                placeholder="请输入收到的手机验证码"
                style="float: left"
              >
                <span slot="prefix">
                  <svg-icon
                    icon-class="icon-yanzhengma"
                    class="color-main inputSvg"
                  />
                </span> </el-input
            ></el-col>
            <el-col :span="8">
              <el-button
                style="
                  margin-left: 5%;
                  height: 50px;
                  background-color: #fff;
                  color: #0080ff;
                "
                type="primary"
                size="medium"
                :loading="captchaloading"
                :disabled="!canClick"
                @click.native.prevent="handlegetCaptcha"
              >
                {{ getCodeText }}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="" style="display: flex; flex-direction: column">
          <el-button
            type="primary"
            :loading="loading"
            @click.native.prevent="onSubmit('passFrom')"
            style="width: 100%; background-color: #0080ff; height: 50px"
          >
            更改密码
          </el-button>
          <el-button
            type="primary"
            @click.native.prevent="close"
            style="
              width: 100%;
              background-color: #eee;
              height: 50px;
              color: #666;
              margin: 20px 0 0 0;
              border: none;
            "
          >
            关闭
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { isvalidUsername } from "@/utils/validate";
import { resetPassword, getCaptcha } from "@/api/login.js";
import { isEmpty, stringToBase64AES } from "@/utils/help";
const defaultPass = {
  password: "",
  npassword: "",
  code: "",
  isreset: true,
};
export default {
  name: "Pass",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (typeof value == "undefined" || value == "") {
        callback(new Error("用户名不能为空"));
      } else if (!isvalidUsername(value)) {
        callback(new Error("请输入正确的用户名"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (typeof value == "undefined" || value == "") {
        callback(new Error("密码不能为空"));
      }
      const passwordMgx =
        /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\._\+(){}])[0-9a-zA-Z!@#$%^&*,\\._\+(){}]{10,100}$/;
      if (!passwordMgx.test(value)) {        
        this.$message({
              message: "密码长度大于10,且必须包含大写、小写、数字、特殊字符(只允许!@#$%^&*.)！",
              type: "error",
            });
        callback(
          new Error("密码长度大于10,且必须包含大写、小写、数字、特殊字符！")
        );
      } else {
        callback();
      }
    };
    const validatePassTwo = (rule, value, callback) => {
      if (typeof value == "undefined" || value == "") {
        callback(new Error("密码不能为空"));
      } else if (this.passFrom.password != this.passFrom.npassword) {
        
        this.$message({
              message: "确认密码与输入密码不一致！,请核对！",
              type: "error",
            });
        callback(new Error("确认密码与输入密码不一致！,请核对！"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("验证码不能为空"));
      } else if (value.length < 6) {
        callback(new Error("验证码为6位数字"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      totaltime: 60,
      getCodeText: "获取手机验证码",
      captchaloading: false,
      canClick: true,
      passFrom: Object.assign({}, defaultPass),
      rules: {
        username: [
          {
            required: true,
            trigger: "blur",
            validator: validateUsername,
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            validator: validatePass,
          },
        ],
        npassword: [
          {
            required: true,
            trigger: "blur",
            validator: validatePassTwo,
          },
        ],
        code: [
          {
            required: true,
            trigger: "blur",
            validator: validateCode,
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    onSubmit(formName) {
      this.loading = true;
      let pwold = JSON.parse(JSON.stringify(this.passFrom.password));
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("是否确认修改密码", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              if (this.passFrom.password != this.passFrom.npassword) {
                this.$message({
                  message: "确认密码与输入密码不一致！,请核对！",
                  type: "error",
                });
                this.loading = false;
                return;
              }
              this.passFrom.password = stringToBase64AES(
                this.passFrom.password
              );
              resetPassword(this.passFrom)
                .then((response) => {
                  this.loading = false;
                  this.$message({
                    message: "修改密码成功",
                    type: "success",
                    duration: 3000,
                  });
                  let _this = this;
                  setTimeout(function () {
                    _this.logout();
                  }, 4000);
                })
                .catch(() => {
                  this.loading = false;
                  this.passFrom.password = pwold;
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
          this.$message({
            message: "验证失败",
            type: "error",
            duration: 1000,
          });
          return false;
        }
      });
    },
    close() {
      this.$emit("cancel");
    },

    verificationCode() {
      if (!this.canClick) return;
      this.getCodeText = this.totaltime + "s后重新发送";
      this.canClick = false;
      let clock = window.setInterval(() => {
        this.totaltime--;
        this.getCodeText = this.totaltime + "s后重新发送";
        if (this.totaltime < 0) {
          window.clearInterval(clock);
          this.getCodeText = "重新发送验证码";
          this.totaltime = 60;
          this.canClick = true;
        }
      }, 1000);
    },
    handlegetCaptcha() {
      if (this.passFrom.username == "") {
        this.$message({
          message: "请输入手机号获取验证码！",
          type: "error",
        });
        return;
      }
      this.captchaloading = true;
      this.passFrom.isreset = true;
      getCaptcha(this.passFrom)
        .then(() => {
          this.captchaloading = false;
          this.$message({
            message: "已发送手机验证码！",
            type: "success",
            duration: 3000,
          });
          this.verificationCode();
        })
        .catch(() => {
          this.captchaloading = false;
        });
    },
  },
};
</script>

<style scoped>
.pub-home {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  background: #fff;
  width: 440px;
  text-align: center;
  border-radius: 20px;
}
.inputSvg {
  font-size: 42px;
}
/deep/ .el-input__inner {
  height: 50px;
  text-indent: 10px;
  background: #ecf2fa;
  color: #2c2c2c;
  border: 0;
  padding-left: 44px;
}
/deep/ .el-input__inner ::placeholder {
  color: #627287;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/Reset.vue